import React from "react"
import MapboxDraw from "@mapbox/mapbox-gl-draw"
import { useControl } from "react-map-gl"
import type { ControlPosition } from "react-map-gl"

type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
  position?: ControlPosition
  onDrawCreate?: (evt: { features: object[] }) => void
  onDrawUpdate?: (evt: { features: object[]; action: string }) => void
  onDrawDelete?: (evt: { features: object[] }) => void
}

const DrawControl = React.forwardRef(function _DrawCtrl(props: DrawControlProps, outerRef: any) {
  const innerRef = React.useRef<any>(null)
  React.useImperativeHandle(outerRef, () => innerRef.current!, [])

  useControl<MapboxDraw>(
    () => {
      const drawCtrl = new MapboxDraw(props)
      innerRef.current = drawCtrl
      return drawCtrl
    },
    ({ map }) => {
      if (typeof props.onDrawCreate === "function") {
        map.on("draw.create", props.onDrawCreate)
      }

      if (typeof props.onDrawUpdate === "function") {
        map.on("draw.update", props.onDrawUpdate)
      }

      if (typeof props.onDrawDelete === "function") {
        map.on("draw.delete", props.onDrawDelete)
      }
    },
    ({ map }) => {
      if (typeof props.onDrawCreate === "function") {
        map.off("draw.create", props.onDrawCreate)
      }

      if (typeof props.onDrawUpdate === "function") {
        map.off("draw.update", props.onDrawUpdate)
      }

      if (typeof props.onDrawDelete === "function") {
        map.off("draw.delete", props.onDrawDelete)
      }
    },
    { position: props.position },
  )

  return null
})

export default DrawControl

export type DrawControlType = typeof DrawControl
